import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
  taxpayerName?: string;
}

const HometaxEqualTinError = ({ onPrimaryButtonClick, taxpayerName = '고객' }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_document-person_md.svg" width={80} height={80} />,
    title: `${taxpayerName}님 정보로 다시 인증해주세요`,
    description: '다른 사용자 정보로 인증되어\n확인이 어려워요.',
    primaryButtonText: '다시 시도',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'filled-primary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default HometaxEqualTinError;
